import React, { useContext, useEffect, useState } from 'react'
import { Button, DatePicker, Descriptions, Empty, Form, Image, Input, Modal, notification, Popconfirm, Select, Spin, Tag, Upload } from 'antd'
import { CheckOutlined, CloseOutlined, DeleteOutlined, PlusOutlined, SaveOutlined } from '@ant-design/icons'
import { useHistory } from 'react-router-dom'
import API from '@aws-amplify/api'
import Storage from '@aws-amplify/storage'
import moment from 'moment'

import { listIncidentReport, listIncidentFile } from '../backend/graphql/queries'
import { submitIncident, updateIncidentFile } from '../backend/graphql/mutations'
import path from '../utils/pathSettings'
import { getAwsExport } from '../utils/awsExportSettings'
import { AppContext } from '../contexts/AppContext'
import imgEmptyImage192 from '../media/Image-EmptyImage-192.png'
import useUnsavedChangesWarning from '../hooks/useUnsavedChangesWarning'

const { Option } = Select
const { TextArea } = Input

const IncidentDraftReportEdit = (props) => {
    const { appState, actionSetPageTitle } = useContext(AppContext)
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false)
    const [loadingImageList, setLoadingImageList] = useState(false)
    const [incident, setIncident] = useState({})
    const [imageListSource, setImageListSource] = useState([])
    const [display, setDisplay] = useState({})
    const dateFormatList = ['DD MMM YYYY HH:mm']
    const validateMessages = {
        required: 'This field is required.',
    }
    const getBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }
    const uploadButton = (
        <div>
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>Upload</div>
        </div>
    )
    const [state, setState] = useState({
        fileList: []
    })
    const history = useHistory()
    const [Prompt, setDirty, setPristine] = useUnsavedChangesWarning()

    const getImageFromStorage = async (array) => {
        // console.log("array", array);
        let arrayUpdate = []
        for (let i = 0; i < array.length; i++) {
            try {
                const result = await Storage.get(array[i].key)
                // console.log("result", result.toString());
                // arrayUpdate.push(result.toString())
                arrayUpdate.push({
                    ...array[i],
                    src: result.toString()
                })
            }
            catch (error) {
                console.log('error:', error);
            }
        }

        setImageListSource(arrayUpdate)
    }

    const getIncidentRecord = async (id) => {
        setLoading(true)
        const user = JSON.parse(localStorage.getItem('isap_cognitouser_site'))
        const profiles = JSON.parse(user.signInUserSession.idToken.payload.profiles)

        try {
            const listIncidentReportDetails = {
                pagination: {
                    agencyID: profiles[0].securityAgencyID, // current fixed to first profile, need to have an attribute to store last agency profile
                },
                filter: {
                    securityAgencyID: {
                        eq: profiles[0].securityAgencyID // current fixed to first profile, need to have an attribute to store last agency profile
                    },
                    id: {
                        eq: id
                    }
                }
            }
            const result = await API.graphql({
                query: listIncidentReport,
                variables: listIncidentReportDetails,
                authMode: 'AMAZON_COGNITO_USER_POOLS'
            })
            // console.log("result", result);
            setIncident(result.data.result.result[0])
            // console.log("result", result.data.result.result[0]);
        }
        catch (error) {
            console.log('error:', error);
            notification.error({
                message: 'Unable to retrieve incident report'
            })
            setLoading(false)
        }

        // if (id !== undefined) {
        //     for (let i = 0; i < dataState.incidentDraftRecords.length; i++) {
        //         if (parseInt(id) === dataState.incidentDraftRecords[i].id) {
        //             setIncident(dataState.incidentDraftRecords[i])
        //             break
        //         }
        //     }
        // }
        // else {
        //     notification.error({
        //         message: "Unable to retrieve incident report"
        //     })
        //     const timer = setTimeout(() => {
        //         setLoading(false)
        //         clearTimeout(timer)
        //     }, 1000)
        // }
    }

    const getIncidentFileRecords = async (id) => {
        setLoadingImageList(true)
        const user = JSON.parse(localStorage.getItem('isap_cognitouser_site'))
        const profiles = JSON.parse(user.signInUserSession.idToken.payload.profiles)
        try {
            const listIncidentFileDetails = {
                filter: {
                    incidentReportID: {
                        eq: id
                    }
                },
                pagination: {
                    agencyID: profiles[0].securityAgencyID, // current fixed to first profile, need to have an attribute to store last agency profile
                }
            }
            const result = await API.graphql({
                query: listIncidentFile,
                variables: listIncidentFileDetails,
                authMode: 'AMAZON_COGNITO_USER_POOLS'
            })
            // console.log("result", result);
            const data = result.data.result
            // console.log("data", data);
            const array = data.result ? data.result : []
            // console.log("array", array);
            if (array.length > 0) {
                await getImageFromStorage(array)
            }
        }
        catch (error) {
            console.log('error:', error);
            notification.error({
                message: 'Unable to retrieve incident report files'
            })
        }
        finally {
            setLoadingImageList(false)
        }
    }

    const uploadFile = async (file) => {
        // console.log(file);
        const user = JSON.parse(localStorage.getItem('isap_cognitouser_site'))
        const profiles = JSON.parse(user.signInUserSession.idToken.payload.profiles)

        const fileName = 'ir_' + moment().utc().format('YYYY-MM-DD_HH:mm:ss') + '_' + file.name
        const fileType = file.type

        try {
            const result = await Storage.put('incident/' + profiles[0].securityAgencyID + '/' + fileName, file, {
                contentType: fileType
            })
            // console.log(result.key);
            return result.key
        }
        catch (error) {
            console.log('error:', error);
            notification.error({
                message: error
            })
        }
    }

    const updateIncidentReportRecord = async (values, imageKeyList, type, id) => {
        const user = JSON.parse(localStorage.getItem('isap_cognitouser_site'))
        const profiles = JSON.parse(user.signInUserSession.idToken.payload.profiles)
        // console.log("user", user);
        // console.log("profiles", profiles);
        try {
            let updateIncidentFile = []
            if (imageKeyList.length !== 0) {
                for (let i = 0; i < imageKeyList.length; i++) {
                    updateIncidentFile.push(
                        {
                            id: 0,
                            bucket: getAwsExport().aws_user_files_s3_bucket,
                            key: imageKeyList[i],
                            region: getAwsExport().aws_user_files_s3_bucket_region,
                        }
                    )
                }
            }
            let incidentDetails = {
                updateIncidentReport: {
                    id: id,
                    securityAgencyID: profiles[0].securityAgencyID, // current fixed to first profile, need to have an attribute to store last agency profile
                    securitySiteID: appState?.siteList?.filter(s => s.id == values.site)[0]?.securitySiteID,
                    siteProfileID: values.site,
                    submittedBy: user.username,
                    submittedByStaffProfileID: profiles[0].staffProfileID,
                    status: type === 'draft' ? 'DRAFT' : values.status,
                },
                updateIncidentDetail: {
                    id: 0,
                    staffProfileID: profiles[0].staffProfileID,
                    type: values.incidentType,
                    title: values.subject,
                    incidentStart: values.incidentDatetimeStart.toISOString().split('.')[0],
                    incidentEnd: values.incidentDatetimeEnd.toISOString().split('.')[0],
                    location: values.incidentLocation,
                    description: values.incidentDescription,
                    // personInvolved not captured by front end
                    action: values.actionsTaken,
                    remarks: values.remarks !== undefined && values.remarks !== null ? values.remarks : ''
                }
            }
            if (updateIncidentFile.length !== 0) {
                incidentDetails = {
                    ...incidentDetails,
                    updateIncidentFile: updateIncidentFile
                }
            }
            // console.log("incidentDetails", incidentDetails);
            const result = await API.graphql({
                query: submitIncident,
                variables: incidentDetails,
                authMode: 'AMAZON_COGNITO_USER_POOLS'
            })
            // console.log("result", result);
            setPristine()
            notification.success({
                message: 'Updated successfully'
            })
            history.push(path('incidentDraft'))
        }
        catch (error) {
            console.log('error:', error);
            notification.error({
                message: 'Unable to update incident report'
            })
            setLoading(false)
        }
    }

    const updateIncidentFileRecord = async (id) => {
        setLoading(true)
        try {
            const incidentFileDetails = {
                update: {
                    id: id,
                    deleted: 1,
                }
            }
            const result = await API.graphql({
                query: updateIncidentFile,
                variables: incidentFileDetails,
                authMode: 'AMAZON_COGNITO_USER_POOLS'
            })
            // console.log("result", result);
            notification.success({
                message: 'Deleted successfully'
            })
        }
        catch (error) {
            console.log('error:', error);
            notification.error({
                message: 'Unable to update incident report'
            })
        }
        finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        getIncidentRecord(props.match.params.id)
        getIncidentFileRecords(props.match.params.id)

        actionSetPageTitle('Edit Incident Report - Draft', true, path('incidentDraft'))

        return () => {
            actionSetPageTitle('', false, '')
        }
    }, [])

    useEffect(() => {
        if (Object.keys(incident).length !== 0) {
            // console.log(incident);
            form.setFieldsValue({
                ...incident,
                // incidentDatetimeStart: moment(new Date(incident.incidentDatetimeStart.replace(/-/g, "/") + " UTC")),
                // incidentDatetimeEnd: moment(new Date(incident.incidentDatetimeEnd.replace(/-/g, "/") + " UTC")),
                // incidentDatetimeStart: moment(new Date(incident.incidentStart.replace(/-/g, "/") + " UTC")),
                // incidentDatetimeEnd: moment(new Date(incident.incidentEnd.replace(/-/g, "/") + " UTC")),
                incidentDatetimeStart: moment.utc(incident.incidentStart).local(),
                incidentDatetimeEnd: moment.utc(incident.incidentEnd).local(),
                incidentType: incident.type,
                site: incident.siteProfileID,
                status: incident.status === 'CLOSED' ? 'CLOSED' : 'OPEN',
                subject: incident.title,
                incidentLocation: incident.location,
                incidentDescription: incident.description,
                actionsTaken: incident.action,
            })
            setDisplay({
                ...incident,
                createdOnDisplay: moment(new Date(incident.createdOn.replace(/-/g, '/') + ' UTC')).format('DD MMM YYYY (ddd), HH:mm'),
                updatedOnDisplay: moment(new Date(incident.updatedOn.replace(/-/g, '/') + ' UTC')).format('DD MMM YYYY (ddd), HH:mm'),
                // incidentDatetimeStartDisplay: moment(new Date(incident.incidentDatetimeStart.replace(/-/g, "/") + " UTC")).format('DD MMM YYYY (ddd), HH:mm'),
                // incidentDatetimeStartDisplay: moment(new Date(incident.incidentStart.replace(/-/g, "/") + " UTC")).format('DD MMM YYYY (ddd), HH:mm'),
                // incidentDatetimeEndDisplay: incident.incidentDatetimeEnd !== "" ? moment(new Date(incident.incidentDatetimeEnd.replace(/-/g, "/") + " UTC")).format('DD MMM YYYY (ddd), HH:mm') : "",
                // incidentDatetimeEndDisplay: incident.incidentEnd !== "" ? moment(new Date(incident.incidentEnd.replace(/-/g, "/") + " UTC")).format('DD MMM YYYY (ddd), HH:mm') : "",
                // statusDisplay: incident.status.slice(0, 1).toUpperCase() + incident.status.slice(1).toLowerCase(),
                // statusColour: incident.status === "CLOSED" ? "green" : "orange"
            })
            setLoading(false)
        }
    }, [incident])

    const onFinish = async (values, type) => {
        // console.log("on finish", values);
        // console.log("uploaded images", state);
        await form.validateFields()
        setLoading(true)
        let imageKeyList = []
        // upload file if any
        if (state.fileList.length > 0) {
            for (let i = 0; i < state.fileList.length; i++) {

                const file = state.fileList[i].originFileObj
                const imageKey = await uploadFile(file)
                imageKeyList.push(imageKey)
                // console.log("imageKey", imageKey);
            }
        }
        // console.log("imageKeyList", imageKeyList);
        await updateIncidentReportRecord(values, imageKeyList, type, props.match.params.id)
        
        // setPristine()
        // const timer = setTimeout(() => {
        //     clearTimeout(timer)
        //     notification.success({
        //         message: "Submitted successfully"
        //     })
        //     history.push(path("incident")) // redirect to created report page from backend response
        // }, 1000)
    }

    const handleDatePickerChange = (date, dateString) => {
        // console.log(date, dateString);
        setDirty()
    }

    const handleFormChange = () => {
        setDirty()
    }

    const handleCancel = () => {
        setState({ ...state, previewVisible: false })
    }

    const handlePreview = async (file) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }

        setState({
            ...state,
            previewImage: file.url || file.preview,
            previewVisible: true,
            previewTitle: file.name || file.url.substring(file.url.lastIndexOf('/') + 1),
        })
    }

    const handleChange = (file) => {
        let { fileList } = file
        setState({ ...state, fileList: fileList })
        setDirty()
    }

    const handleCancelUpdate = () => {
        history.push(path('incidentDraft'))
    }

    const handleSaveAsDraft = () => {
        // console.log("on finish", form.getFieldsValue());
        // console.log("uploaded images", state);
        setLoading(true)
        setPristine()
        const timer = setTimeout(() => {
            clearTimeout(timer)
            notification.success({
                message: 'Updated successfully'
            })
            history.push(path('incidentDraft'))
        }, 1000)
    }

    const handleImageDelete = (id) => {
        // console.log("file id", id);
        updateIncidentFileRecord(id)
    }

    const disabledDate = (current) => {
        // Cannot select days next day onwards
        return current > moment().endOf('day');
    }

    const renderListOptions = (array, stringId) => {

        const listOptions = array.map((item, index) => {
            if (stringId !== undefined && stringId === 1) {
                return (
                    <Option key={item.id} value={item.id.toString()}>{item.name}</Option>
                )
            }
            else {
                return (
                    <Option key={item.id} value={item.id}>{item.name}</Option>
                )
            }
        })

        return listOptions
    }

    const renderSiteListOptions = (array) => {
        // console.log("array", array);
        if (array.length !== 0) {
            const listOptions = array.map((item, index) => {
                return (
                    <Option key={item.id} value={item.id}>{item.name}</Option>
                )
            })

            return listOptions
        }
        else {
            return (
                <div />
            )
        }
    }

    const renderImages = (array) => {
        const images = array.map((item) => {
            return (
                <div key={item.id} style={{ display: 'flex', alignItems: 'center' }}>
                    <Image
                        width={100}
                        src={item.src !== null ? item.src : ''}
                        fallback={imgEmptyImage192}
                    />
                    <Popconfirm title={
                        <div>
                            This is an irreversible action.
                            Are you sure?
                        </div>
                    } onConfirm={() => handleImageDelete(item.id)} okText="Yes" cancelText="No">
                        <Button shape="circle" icon={<DeleteOutlined />} />
                    </Popconfirm>
                    &nbsp;&nbsp;
                </div>
            )
        })
        return images
    }

    const renderUploadImages = (array) => {
        return (
            (array.length === 0) ? (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            ) : (
                <div className="row">
                    <Image.PreviewGroup>
                        {renderImages(array)}
                    </Image.PreviewGroup>
                </div>
            )
        )
    }

    return (
        <div className="container-content allow-overflow">
            <Spin spinning={loading}>
                <div className="content-content">
                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={onFinish}
                        validateMessages={validateMessages}
                        requiredMark={false}
                    >
                        <Descriptions
                            title={
                                <div className="row spaceBetween">
                                    <div>
                                        <span>{appState.profileAgency.securityAgencyName}</span> <Tag>Security Site</Tag>
                                    </div>
                                    <div>
                                        <Button onClick={handleCancelUpdate} shape={appState.broken === true ? 'circle' : ''} icon={<CloseOutlined />}>
                                            {appState.broken === true ? '' : 'Cancel'}
                                        </Button>
                                        &nbsp;&nbsp;
                                        <Button onClick={() => onFinish(form.getFieldsValue(), 'draft')} shape={appState.broken === true ? 'circle' : ''} icon={<SaveOutlined />}>
                                            {appState.broken === true ? '' : 'Save as Draft'}
                                        </Button>
                                        &nbsp;&nbsp;
                                        <Popconfirm title={
                                            <div>
                                                Are you sure?<br />
                                                No amendments can be made once report is submitted.
                                            </div>
                                        } onConfirm={() => onFinish(form.getFieldsValue(), 'submit')} okText="Yes" cancelText="No" placement="topRight">
                                            <Button type="primary" htmlType="submit" shape={appState.broken === true ? 'circle' : ''} icon={<CheckOutlined />}>
                                                {appState.broken === true ? '' : 'Submit'}
                                            </Button>
                                        </Popconfirm>
                                    </div>
                                </div>
                            }
                            bordered
                            column={{ xs: 1, sm: 2 }}
                        >
                            <Descriptions.Item label="Report UID" span={2}>
                                {display.uid}
                                <div className="sub-italic">
                                    {
                                        display.createdOnDisplay !== display.updatedOnDisplay ? (
                                            <span>
                                                Last updated: {display.updatedOnDisplay}
                                                <br />
                                                Created On: {display.createdOnDisplay}
                                            </span>
                                        ) : (
                                            <span>Created On: {display.createdOnDisplay}</span>
                                        )
                                    }
                                </div>
                            </Descriptions.Item>
                            {/* <Descriptions.Item label="Site">{display.siteName}</Descriptions.Item> */}
                            <Descriptions.Item label="Submitted By">{display.submittedByStaffName}</Descriptions.Item>
                        </Descriptions>
                        <br />
                        {/* <Form.Item
                            label="Report UID"
                            name="reportUID"
                            rules={[
                                {
                                    required: true,
                                },
                            ]}
                        >
                            <Input autoComplete="off" placeholder="Enter report UID" disabled={true} />
                        </Form.Item>
                        <Form.Item
                            label="Site"
                            name="site"
                            rules={[
                                {
                                    required: true,
                                },
                            ]}
                        >
                            <Input autoComplete="off" placeholder="Enter site" disabled={true} />
                        </Form.Item> */}
                        <Form.Item
                            label="Incident Type"
                            name="incidentType"
                            rules={[
                                {
                                    required: true,
                                },
                            ]}
                        >
                            <Select
                                showSearch
                                placeholder="Select incident type"
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                onChange={handleFormChange}
                            >
                                {renderListOptions(appState.incidentTypeList)}
                            </Select>
                        </Form.Item>
                        <Form.Item
                            label="Status"
                            name="status"
                            rules={[
                                {
                                    required: true,
                                },
                            ]}
                        >
                            <Select
                                showSearch
                                placeholder="Select status"
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                onChange={handleFormChange}
                            >
                                <Option key="OPEN" value="OPEN">Open</Option>
                                <Option key="CLOSED" value="CLOSED">Closed</Option>
                            </Select>
                        </Form.Item>
                        <Form.Item
                            label="Subject"
                            name="subject"
                            rules={[
                                {
                                    required: true,
                                },
                            ]}
                        >
                            <Input autoComplete="off" placeholder="Enter subject" onChange={handleFormChange} />
                        </Form.Item>
                        <Form.Item
                            label="Site"
                            name="site"
                        >
                            <Select
                                showSearch
                                placeholder="Select site"
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                {renderSiteListOptions(appState.siteList)}
                            </Select>
                        </Form.Item>
                        <Form.Item
                            label="Incident Datetime Start"
                            name="incidentDatetimeStart"
                            rules={[
                                {
                                    required: true,
                                },
                            ]}
                        >
                            <DatePicker showTime onChange={handleDatePickerChange} format={dateFormatList} disabledDate={disabledDate} />
                        </Form.Item>
                        <Form.Item
                            label="Incident Datetime End"
                            name="incidentDatetimeEnd"
                            rules={[
                                {
                                    required: true,
                                },
                            ]}
                        >
                            <DatePicker showTime onChange={handleDatePickerChange} format={dateFormatList} disabledDate={disabledDate} />
                        </Form.Item>
                        <Form.Item
                            label="Incident Location"
                            name="incidentLocation"
                            rules={[
                                {
                                    required: true,
                                },
                            ]}
                        >
                            <Input autoComplete="off" placeholder="Enter incident location" onChange={handleFormChange} />
                        </Form.Item>
                        {/* <Form.Item
                            label="People Involved"
                            name="peopleInvolved"
                        >
                            <TextArea rows={2} autoComplete="off" placeholder="Enter people involved" />
                        </Form.Item> */}
                        <Form.Item
                            label="Incident Description"
                            name="incidentDescription"
                            rules={[
                                {
                                    required: true,
                                },
                            ]}
                        >
                            <TextArea rows={4} autoComplete="off" placeholder="Enter incident description" onChange={handleFormChange} />
                        </Form.Item>
                        <Form.Item
                            label="Actions Taken"
                            name="actionsTaken"
                            rules={[
                                {
                                    required: true,
                                },
                            ]}
                        >
                            <TextArea rows={3} autoComplete="off" placeholder="Enter actions taken" onChange={handleFormChange} />
                        </Form.Item>
                        <Form.Item
                            label="Remarks"
                            name="remarks"
                        >
                            <TextArea rows={2} autoComplete="off" placeholder="Enter remarks" onChange={handleFormChange} />
                        </Form.Item>
                        <Form.Item
                            label="Upload Image(s)"
                        >
                            <Upload
                                action={getBase64}
                                listType="picture-card"
                                fileList={state.fileList}
                                onPreview={handlePreview}
                                onChange={(file) => handleChange(file)}
                                multiple={true}
                            >
                                {state.fileList.length >= 5 ? null : uploadButton}
                            </Upload>
                            <Modal
                                visible={state.previewVisible}
                                title={state.previewTitle}
                                footer={null}
                                onCancel={handleCancel}
                            >
                                <img alt="upload preview" style={{ width: '100%' }} src={state.previewImage} />
                            </Modal>
                        </Form.Item>
                        {
                            // display.imagesKey !== undefined && JSON.parse(display.imagesKey).length !== 0 ? (
                            imageListSource.length !== 0 ? (
                                <Form.Item
                                    label="Uploaded Image(s)"
                                >
                                    <Spin spinning={loadingImageList}>
                                        {/* {renderUploadImages(display.imagesKey !== undefined ? JSON.parse(display.imagesKey) : [])} */}
                                        {renderUploadImages(imageListSource)}
                                    </Spin>
                                </Form.Item>
                            ) : (
                                <div />
                            )
                        }
                        <div className="button">
                            <Button onClick={handleCancelUpdate}>Cancel</Button>
                            &nbsp;&nbsp;
                            <Button onClick={() => onFinish(form.getFieldsValue(), 'draft')}>Save as Draft</Button>
                            &nbsp;&nbsp;
                            <Popconfirm title={
                                <div>
                                    Are you sure?<br />
                                    No amendments can be made once report is submitted.
                                </div>
                            } onConfirm={() => onFinish(form.getFieldsValue(), 'submit')} okText="Yes" cancelText="No">
                                <Button type="primary" htmlType="submit">Submit</Button>
                            </Popconfirm>
                        </div>
                    </Form>
                </div>
            </Spin>
            {Prompt}
        </div>
    )
}

export default IncidentDraftReportEdit